import React from 'react'
import { WorkspaceSsoConfigFragment } from '@sketch/gql-types'

import {
  NeedHelpSection,
  WorkspaceSettingsEnableSsoPanel,
  WorkspaceSettingsScimPanel,
  WorkspaceSettingsSsoSetupPanel,
  WorkspaceSettingsSsoUpsell,
} from '../../components'

interface WorkspaceSettingsSsoProps {
  customerId: string
  workspaceId: string
  ssoShortName?: string
  isSsoActive: boolean
  isScimEnabled: boolean
  isScimAccessEnabled: boolean
  scimEndpoint?: string
  showUpsell: boolean
  config?: WorkspaceSsoConfigFragment
}

export const WorkspaceSettingsSso: React.FC<WorkspaceSettingsSsoProps> = ({
  customerId,
  workspaceId,
  ssoShortName,
  isSsoActive,
  isScimEnabled,
  isScimAccessEnabled,
  scimEndpoint,
  config,
  showUpsell,
}) => {
  if (ssoShortName && !showUpsell) {
    return (
      <>
        <WorkspaceSettingsSsoSetupPanel
          customerId={customerId}
          workspaceShortName={ssoShortName}
          isSsoActive={isSsoActive}
          config={config!}
        />
        {isScimAccessEnabled && (
          <WorkspaceSettingsScimPanel
            workspaceId={workspaceId}
            isSsoEnabled={isSsoActive}
            isScimEnabled={isScimEnabled}
            scimEndpoint={scimEndpoint}
          />
        )}
        <NeedHelpSection />
      </>
    )
  }

  return (
    <>
      {showUpsell && <WorkspaceSettingsSsoUpsell />}
      <WorkspaceSettingsEnableSsoPanel
        customerId={customerId}
        showUpsell={showUpsell}
      />
    </>
  )
}
